import LazyGsap from '@/utils/Controllers/LazyGsapController';

const CTA_SELECTOR = '.js-pdp-open-selector';
const DRAWER_ID = 'js-pdp-drawer-selector';
const MASK_SELECTOR = '#js-pdp-drawer-selector__mask';
const CONTENT_SELECTOR = '#js-pdp-drawer-selector__content';
const CLOSE_CTA_SELECTOR = '#js-pdp-drawer-selector__close-cta';

let gsap;
let drawerEl;
let maskEl;
let contentEl;
let closeCtaEl;

const toggleBodyScroll = lock => {
  const overflow = lock ? 'hidden' : 'unset';
  gsap.set(document.body, { overflow });
  gsap.set(document.documentElement, { overflow });
};

const closeDrawer = async () => {
  ({ gsap } = await LazyGsap());
  const tl = gsap.timeline();
  toggleBodyScroll(false);
  tl.to(contentEl, { right: '-100%', duration: 0.7 })
    .to(maskEl, { opacity: 0, duration: 0.5 }, '-=.5')
    .set(drawerEl, { display: 'none' }, '+=.5');
};

const openDrawer = async () => {
  ({ gsap } = await LazyGsap());
  const tl = gsap.timeline();
  toggleBodyScroll(true);
  tl.set(contentEl, { right: '-100%' })
    .set(maskEl, { opacity: 0 })
    .set(drawerEl, { display: 'block' })
    .to(maskEl, { opacity: 1 })
    .to(contentEl, { right: 0 }, '-=.5');
};

export default function init() {
  try {
    const ctas = document.querySelectorAll(CTA_SELECTOR);
    if (ctas.length > 0) {
      drawerEl = document.getElementById(DRAWER_ID);
      maskEl = drawerEl.querySelector(MASK_SELECTOR);
      contentEl = drawerEl.querySelector(CONTENT_SELECTOR);
      closeCtaEl = drawerEl.querySelector(CLOSE_CTA_SELECTOR);

      if (!drawerEl || !maskEl || !contentEl || !closeCtaEl)
        throw new Error('Required elements are not available');

      if (maskEl) maskEl.addEventListener('click', closeDrawer);
      if (closeCtaEl) closeCtaEl.addEventListener('click', closeDrawer);

      ctas.forEach(cta => {
        cta.addEventListener('click', openDrawer);
      });
    }
  } catch (error) {
    console.info('PdpVariantsSelectorController::init');
    console.error(error);
  }
}
